import { IMapLibrePolygonsStyle } from "@ryde/controls";

/** Screen padding (px) left around the area polygons when the map frames them. */
export const FIT_BOUNDS_PADDING_PX = 24;

export const POLYGON_FILL_OPACITY = 0.25;

export const POLYGON_WEIGHT = 2;

/** A ring needs three corners before it encloses anything to test against. */
export const MIN_POLYGON_POINTS = 3;

/**
 * How the stations map paints an area overlay. A module constant, not an inline object: the polygons
 * layer rebuilds its whole FeatureCollection when this identity changes, and area rings are the large
 * ones — the grid deliberately strips them from its rows.
 */
export const STATIONS_AREA_POLYGONS_STYLE: Partial<IMapLibrePolygonsStyle> = {
  fillOpacity: POLYGON_FILL_OPACITY,
  weight: POLYGON_WEIGHT,
};
